export default class CustomPalette {
  constructor(bpmnFactory, create, elementFactory, palette, translate) {
    this.bpmnFactory = bpmnFactory;
    this.create = create;
    this.elementFactory = elementFactory;
    this.translate = translate;

    palette.registerProvider(this);
  }

  // eslint-disable-next-line no-unused-vars
  getPaletteEntries(element) {
    const { bpmnFactory, create, elementFactory, translate } = this;

    function createTask() {
      return function(event) {
        const businessObject = bpmnFactory.create("bpmn:ServiceTask");        

        const shape = elementFactory.createShape({
          type: "bpmn:ServiceTask",
          businessObject: businessObject,
        });

        shape.custom_type = "AutomatonCall";

        create.start(event, shape);
      };
    }

    function createAPICallTask() {
      return function(event) {
        const businessObject = bpmnFactory.create("bpmn:ServiceTask");        

        const shape = elementFactory.createShape({
          type: "bpmn:ServiceTask",
          businessObject: businessObject,
        });

        shape.custom_type = "APICall";        

        create.start(event, shape);
      };
    }

    return {
      "create.low-task": {
        group: "activity",
        className: "bpmn-icon-service-task red",
        title: translate("Automate task"),
        action: {
          dragstart: createTask(),
          click: createTask(),
        },
      },
      "create.api-call-task": {
        group: "activity",
        className: "bpmn-icon-service-task green",
        title: translate("API Call task"),
        action: {
          dragstart: createAPICallTask(),
          click: createAPICallTask(),
        },
      },
    };
  }
}

CustomPalette.$inject = [
  "bpmnFactory",
  "create",
  "elementFactory",
  "palette",
  "translate",
];
